import { useMemo } from "react"
import { ISizeStandard } from "../../../../types/wizard"

export default function SizeSummary({ content }: { content: ISizeStandard }) {
  const dimensions = useMemo(() => {
    let dimensionStrings = ""
    if (content?.width && content?.height && !content?.scaleHeight && !content?.scaleWidth) {
      dimensionStrings = `${content?.width}" x ${content?.height}"`
    } 
    else if (content?.width && content?.scaleHeight) {
      dimensionStrings = `${content?.width}", Scale Height`
    }
    else if (content?.height && content?.scaleWidth) {
      dimensionStrings = `Scale Width, ${content?.height}"`
    }
    return dimensionStrings
  }, [content])
  

  return (
    <div className="flex gap-2 items-center text-md font-bold text-xl">
      {dimensions ? (
        <>
          <h3>Custom: </h3>
          <p>
          {dimensions}
          </p>
        </>
      ) : null}
    </div>
  )
}